import { render } from "./ServiceCoupons.vue?vue&type=template&id=48bbe1c4&lang=true"
import script from "./ServiceCoupons.vue?vue&type=script&lang=js"
export * from "./ServiceCoupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/ServiceCoupons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48bbe1c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48bbe1c4', __exports__)) {
    api.reload('48bbe1c4', __exports__)
  }
  
  module.hot.accept("./ServiceCoupons.vue?vue&type=template&id=48bbe1c4&lang=true", () => {
    api.rerender('48bbe1c4', render)
  })

}


export default __exports__